<template>
  <div class="status-bar" role="contentinfo" aria-label="Application status bar">
    <div class="status-bar__status">
      <slot name="status">
        <slot name="left" />
        <slot name="center" />
      </slot>
    </div>
    <!-- <div class="status-bar__actions">
      <slot name="actions">
        <div class="status-bar__item">
          <slot name="theme-toggle" />
        </div>
        <div class="status-bar__item">
          <slot name="notifications" />
        </div>
        <slot name="right" />
      </slot>
    </div> -->
  </div>
</template>

<script setup lang="ts">
// StatusBar component for global layout
// Provides a VSCode-style status bar fixed to the bottom of the viewport
</script>

<style scoped lang="scss">
.status-bar {
  /* Now participates in parent grid (App.vue) instead of fixed positioning */
  height: var(--status-bar-height);
  background: var(--vscode-statusBar-background);
  border-top: 1px solid var(--vscode-statusBar-border, var(--vscode-widget-border));
  color: var(--vscode-statusBar-foreground);
  font-size: 12px;
  font-family: var(--vscode-editor-font-family, 'Monaco', 'Menlo', 'Ubuntu Mono', monospace);
  display: grid;
  grid-template-columns: 1fr auto; /* status | actions */
  align-items: stretch;
  padding: 0 4px;
  gap: 4px;
  user-select: none;
  min-width: 0;

  &__status {
    display: flex;
    align-items: center;
    justify-content: flex-end; /* align status items to the right */
    gap: 6px;
    min-width: 0;
    overflow: visible; /* Allow badges to overflow */
    padding: 0 4px;
  }

  &__actions {
    display: flex;
    align-items: center;
    gap: 2px;
    padding-right: 4px;
    overflow: visible; /* Allow badges to overflow */
  }

  &__item {
    display: flex;
    align-items: center;
    height: 100%;
    padding: 0 4px;
    border-radius: 2px;
    transition: background-color 0.1s ease;
    cursor: pointer;
    position: relative;

    &:hover { background: var(--vscode-statusBarItem-hoverBackground); }
    &:active { background: var(--vscode-statusBarItem-activeBackground); }

    :deep(.btn) {
      height: 100%;
      min-height: auto;
      padding: 0 4px;
      font-size: 11px;
      border-radius: 0;
      background: transparent !important;
      display: flex;
      align-items: center;
      justify-content: center;
      &:hover { background: transparent !important; }
      &:focus { outline: 1px solid var(--vscode-focusBorder); outline-offset: -1px; }
    }
    :deep(.btn--icon) { min-width: auto; width: 100%; }
  }
}

@media (prefers-contrast: high) {
  .status-bar {
    border-top: 1px solid var(--vscode-contrastBorder);
    &__item { border: 1px solid transparent; &:hover { border-color: var(--vscode-contrastActiveBorder); } }
  }
}

:global(:root) { --status-bar-height: 1.75rem; }
</style>
